import React, { useState, useEffect, useMemo } from "react";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { useAuth } from "../../context/AuthContext.js";
import api from "../../utils/apiClient";
import { useNavigate } from "react-router-dom";
import CarSelect from "../CarSelect";
import "../../style/AllCarsAdmin.css";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";


function CreateAuction() {
  const { authToken, logout } = useAuth();
  const [username, setUsername] = useState("");
  const [carros, setCarros] = useState([]);
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const getuser = async () => {
      try {
        const response = await api.get("usuario/getbyToken");
        setUsername(response.data.nombre);
      } catch (error) {
        console.error("Error fetching user", error);
      }
    };

    const fetchCars = async () => {
      try {
        const res = await api.get("carro?limit=200");
        setCarros(res.data.carros || []);
      } catch (error) {
        console.error("Error fetching cars", error);
      }
    };

    if (!authToken) {
      navigate("/");
    }
    getuser();
    fetchCars();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtered = useMemo(() => {
    const term = search.toLowerCase();
    return carros.filter(
      (c) =>
        c.marca.toLowerCase().includes(term) ||
        c.modelo.toLowerCase().includes(term) ||
        c.anio.toString().includes(term) ||
        c.lote.toString().includes(term)
    );
  }, [search, carros]);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-admin-a">
        <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-all">
          <AdminSidebarDropdown onLogout={handleLogout} />
            <p className="main-admin-title-a">Selecciona un Auto</p>
            <div className="search-bar-a">
              <input
                type="text"
                id="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Buscar por marca, modelo, año o lote"
              />
            </div>
            <div
              className="overview-container-admin"
              style={{ overflow: "auto", maxHeight: "700px", alignItems: "flex-start" }}
            >
              {filtered.map((carro) => (
                <div className="overview-item-boletin" key={carro._id}>
                  <CarSelect carro={carro} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default CreateAuction;
